import React from "react";
import { IIcons } from "./icons";

const NotEditable = ({ fillColor }: IIcons.IconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={fillColor}
    >
      <path
        d="M9.76316 3.07919L1 11.8424V15.0002H4.15789L12.9211 6.23709L9.76316 3.07919ZM10.9474 1.89498L12.8421 0.000244141L16 3.15814L14.1053 5.05288L10.9474 1.89498Z"
        fill="#ACACAC"
      />
      <rect
        x="0.496094"
        y="1.41431"
        width="2"
        height="19.926"
        transform="rotate(-45 0.496094 1.41431)"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export default NotEditable;
